import { combineEpics, ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators';

import { Epic } from 'src/config/rootEpic';
import { APP_INIT } from 'src/shared/actions/sharedActions';
import { Contentful } from 'src/shared/services/Contentful';

import { fetchVideosDataFail, fetchVideosDataSuccess } from '../actions/videosActions';

export function videosEpicFactory(contentfulService: Contentful): Epic {
    const fetchVideosDataEpic: Epic = action$ =>
        action$.pipe(
            ofType(APP_INIT),
            switchMap(() =>
                contentfulService
                    .getAllVideos()
                    .then(fetchVideosDataSuccess)
                    .catch(fetchVideosDataFail),
            ),
        );

    return combineEpics(fetchVideosDataEpic);
}
